export default class Public {
    static mainImg = 'http://iryoss.oss-cn-beijing.aliyuncs.com/img/ReplenishingNightCream/main.jpg';
    static logo = 'http://iryoss3-0.oss-cn-beijing.aliyuncs.com/manager/logo1.jpg';
    static defaultImg ='http://chenglianyijia.oss-cn-beijing.aliyuncs.com/manager/addImg.svg';
    static defaultImg1 ='http://chenglianyijia.oss-cn-beijing.aliyuncs.com/manager/defaultImg.png';
    static idcardReg =/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/; // 身份证号验证
    static from ={
        iry: '1' // 爱润妍
    }; // 商品渠道
    static status ={
        draft: '5', // 草稿箱
        warehouse: '1', // 仓库中
        advance: '2', // 预售中
        sale: '3', // 在售中
        all: ['1', '2', '3']
    }; // 商品列表状态
    static detail ={
        examine: '0', // 审核
        warehouse: '1', // 仓库中
        advance: '2', // 预售中
        sale: '3', // 在售中
        cancel: '4', // 撤销审核
        normal: '5' // 普通
    }; // 详情页操作按钮状态
    static role ={
        normal: 0, // 普通用户
        maker: 1, // 创客
        general: 2, // 总代
        vip: 3, // vip
        area: 4, // 区
        city: 5, // 市
        province: 6, // 省
        normalAgent: [1, 2, 3],
        quota: [2, 3],
        areaAgent: [4, 5, 6]
    }; // 代理商身份
    static artExamine ={
        draft: '0', // 草稿箱
        wait: '1', // 提交审核
        fail: '2', // 审核失败
        success: '3' // 审核成功
    }; // 文章列表审核状态
    static examine ={
        being: 0, // 审核中
        pass: 1, // 通过
        fail: 2 // 失败
    }; // 代理商审核状态
    static withdraw ={
        being: 0, // 待审核
        pass: 1, // 通过
        fail: 2 // 失败
    }; // 提现审核状态
    static manager ={
        provider: '1' // 供货商
    }; // 权限组id
    static finStatus = {
        frozen: 0, // 冻结中
        thaw: 1, // 解冻
        back: 6 // 解冻
    }; // 分润记录交易类型
    static reward = {
        sup: 0, // 上一级返
        area: 1, // 区返
        city: 2, // 市返
        province: 3, // 省返
        owner: 4, // 群主返利
        Breeding: 5, // 培育奖返利
        system: 6 // 系统返利
    }; // 分润记录交易类型
};
